var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"logos"},[_c('a',{staticClass:"logo-link",attrs:{"href":"https://autopay.pl/","title":"Idź do strony Autopay"}})])])
}]

export { render, staticRenderFns }